import Cookies from 'js-cookie';
import { safeNext } from '../scripts/return-to';

// Single sign-on's way back (templates/sso.php): ssosrv sent the browser here
// with a one-minute ticket for the address the team's identity provider
// vouched for; tempstickapi's POST /login/sso turns it into a sign-in.
const box = document.querySelector('.sso-callback');

if(box) {

  const params = new URLSearchParams(window.location.search);
  const ticket = params.get('ticket') || '';
  const next = safeNext(params.get('next'));

  // the ticket out of the address bar and the history at once: it works once anyway
  window.history.replaceState(null, '', window.location.pathname);

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const failed = message => {
    $(box).find('.user-login-heading').text("Single sign-on didn't finish");
    $(box).find('.sso-callback-message').html(`${esc(message)}<br /><br /><a class="button button--medium button--black" href="${window.site.home}/login">Back to sign in</a>`);
  };

  if(!ticket) {
    failed('This link has no sign-in in it. Start again from the sign-in page.');
  } else {
    $.ajax({
      url: window.site.api + '/login/sso',
      type: 'post',
      data: { ticket },
      dataType: 'json',
      success: r => {
        if(r.type !== 'success') {
          failed(r.message);
          return;
        }
        window.localStorage.setItem('token', r.data.token);
        Cookies.set('token', encodeURIComponent(r.data.token), { expires: 365 });
        window.location.replace(window.site.home + (next || '/dashboard'));
      },
      error: () => failed('You might not be connected to the internet. Please try again.'),
    });
  }

}
